import { render, staticRenderFns } from "./QBRPlantCodeMaintain.vue?vue&type=template&id=622fda32&scoped=true"
import script from "./QBRPlantCodeMaintain.vue?vue&type=script&lang=js"
export * from "./QBRPlantCodeMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622fda32",
  null
  
)

export default component.exports